import { Link } from 'react-router-dom';

export interface RelatedLink {
  label: string;
  path: string;
}

export interface RelatedGroup {
  heading: string;
  links: RelatedLink[];
}

/**
 * Internal-linking layer used at the bottom of programmatic pages.
 * Dense internal links help search engines crawl the long tail and
 * pass authority between related pages. Use 2-4 groups, 5-10 links
 * each - more than that gets ignored as link spam.
 */
export function RelatedSearches({ groups }: { groups: RelatedGroup[] }) {
  if (groups.length === 0) return null;
  return (
    <section className="mt-12 rounded-2xl border bg-muted/30 p-6">
      <h2 className="text-lg font-semibold text-foreground">Related searches</h2>
      <div className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {groups.map((g) => (
          <div key={g.heading}>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              {g.heading}
            </h3>
            <ul className="mt-2 flex flex-col gap-1.5">
              {g.links.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-sm text-foreground/90 hover:text-primary hover:underline">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
